import { ReactNode, forwardRef } from 'react';
import type { CommonHTMLButtonAttributes } from '@frontend/types';
import { NakedButton } from '../../../naked';
import { TabsStyles } from '../common-styles';

type Props = CommonHTMLButtonAttributes & {
  children: ReactNode;
  id: string;
  trackingId?: string;
  isActive: boolean;
};

export const Tab = forwardRef<HTMLButtonElement, Props>(({ children, isActive, ...rest }: Props, ref) => {
  const styles = TabsStyles.tabItem;

  return (
    <NakedButton ref={ref} css={styles} {...rest}>
      {children}
    </NakedButton>
  );
});
